module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column resumo-subsidio",
    attrs: {
      "id": "dashboard"
    }
  }, [_c('Filtro', {
    attrs: {
      "valorTotalDoProjeto": this.valorTotalDoProjeto
    },
    on: {
      "atualizarDadosDoFiltro": _vm.atualizarDadosDoFiltro
    }
  }), _vm._v(" "), _c('DashboardParaMcmvCidades', {
    attrs: {
      "dadosDoFiltro": this.dadosDoFiltro
    },
    on: {
      "atualizarValorTotal": _vm.atualizarValorTotal
    }
  }), _vm._v(" "), _c('DashboardProjetos', {
    attrs: {
      "dadosDoFiltro": this.dadosDoFiltro
    },
    on: {
      "atualizarValorTotal": _vm.atualizarValorTotal
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0fba1707", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fba1707"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Dashboard.vue
// module id = 1090
// module chunks = 1